module.exports = __webpack_public_path__ + "img/text-classify13.6b9ff7aa.png";